import { HttpClient } from "@angular/common/http";
import { inject, Inject, Injectable } from "@angular/core";
import { EnvConfig, Environment } from "@doc/core";
import { ApiUrls } from "../backoffice-urls";
import { Observable } from "rxjs";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class PrecedentDashboardService {
  private http = inject(HttpClient);
  private apiUrl: string;

  constructor(@Inject(EnvConfig) private config: Environment) {
    this.apiUrl = this.config.apiUrl;
  }

  private _headerDataSubject = new BehaviorSubject<any>(null);
  headerData$ = this._headerDataSubject.asObservable();

  private _typeDataSubject = new BehaviorSubject<any>(null);
  typeData$ = this._typeDataSubject.asObservable();

  private _secondHeaderDataSubject = new BehaviorSubject<{
    left: any;
    right: any;
  }>({
    left: null,
    right: null,
  });
  secondHeaderDataSubject$ = this._secondHeaderDataSubject.asObservable();

  private _chartDataSubject = new BehaviorSubject<any>(null);
  chartDataSubject$ = this._chartDataSubject.asObservable();


  setChartData(data: any) {
    this._chartDataSubject.next(data);
  }

  get currentChartData() {
    return this._chartDataSubject.value;
  }

  setSecondHeaderDataLeft(data: any) {
    const current = this._secondHeaderDataSubject.value;
    this._secondHeaderDataSubject.next({ ...current, left: data });
    this.setChartData(null);
  }

  setSecondHeaderDataRight(data: any) {
    const current = this._secondHeaderDataSubject.value;
    this._secondHeaderDataSubject.next({ ...current, right: data });
    this.setChartData(null);
  }
  get currentSecondHeaderDataLeft() {
    return this._secondHeaderDataSubject.value.left;
  }

  get currentSecondHeaderDataRight() {
    return this._secondHeaderDataSubject.value.right;
  }

  setHeaderData(data: any) {
    this._headerDataSubject.next(data);
    this.setTypeData(null);
  }

  get currentHeaderData() {
    return this._headerDataSubject.value;
  }

  setTypeData(data: any) {
    this._typeDataSubject.next(data);
    this.setSecondHeaderDataLeft(null);
    this.setSecondHeaderDataRight(null);
  }

  get currentTypeData() {
    return this._typeDataSubject.value;
  }

  GetPrecedentDocumentDetails(body: any) {
    const link = this.apiUrl + ApiUrls.GetPrecedentDocumentDetails;
    return this.http.post<any>(link, body);
  }

  getParticipantsAccordionData(body: any) {
    const link = this.apiUrl + ApiUrls.getGetDocumentPomDetails;
    return this.http.post<any>(link, body);
  }

  GetPrecedentAllDocuments(body: any) {
    const link = this.apiUrl + ApiUrls.GetPrecedentAllDocuments;
    return this.http.post<any>(link, body);
  }

  GetPrecedentDashboardCounts(body: any) {
    const link = this.apiUrl + ApiUrls.GetPrecedentDashboardCounts;
    return this.http.post<any>(link, body);
  }

  GetStatusCounts(body: any) {
    const link = this.apiUrl + ApiUrls.GetStatusCounts;
    return this.http.post<any>(link, body);
  }

  GetPrecedentCategoryTwoCounts(body: any) {
    const link = this.apiUrl + ApiUrls.GetPrecedentCategoryTwoCounts;
    return this.http.post<any>(link, body);
  }

  GetParticipationMinutesPerDep(body: any) {
    const link = this.apiUrl + ApiUrls.GetParticipationMinutesPerDep;
    return this.http.post<any>(link, body);
  }

  GetParticipantNamesPerDep(body: any) {
    const link = this.apiUrl + ApiUrls.GetParticipantNamesPerDep;
    return this.http.post<any>(link, body);
  }

  GetRecommendationsCount(body: any) {
    const link = this.apiUrl + ApiUrls.GetRecommendationsCount;
    return this.http.post<any>(link, body);
  }

  ExportPrecedentDashboardData(body: any) {
    const link = this.apiUrl + ApiUrls.ExportPrecedentDashboardData;
    return this.http.post<any>(link, body);
  }

  GetRecommendationDetails(body: any) {
    const link = this.apiUrl + ApiUrls.GetRecommendationDetails;
    return this.http.post<any>(link, body);
  }

  GetPrecedentCategoryTwoMonthlyCounts(body: any) {
    const link = this.apiUrl + ApiUrls.GetPrecedentCategoryTwoMonthlyCounts;
    return this.http.post<any>(link, body);
  }

  GetDocumentWorkFlowDetails(body: any) {
    const link = this.apiUrl + ApiUrls.GetDocumentWorkFlowDetails;
    return this.http.post<any>(link, body);
  }

  FilterDropDownValues(id: any) {
    const link = this.apiUrl + ApiUrls.FilterDropDownValues + "?" + id;
    return this.http.get<any>(link);
  }

  ExportReport(requestObject: any): Observable<any> {
    const url = this.apiUrl + ApiUrls.DownloadReport;
    return this.http.post(url, requestObject, { responseType: "blob" });
  }

  GetDashboardSubject(id: number) {
    const link = this.apiUrl + ApiUrls.GetDashboardSubject + "/" + id;
    return this.http.get<any>(link);
  }

  docType: any = 'initialDocType';      // or get from API
  chartType: any = 'initialChartType';

  private chartTypeSubject = new BehaviorSubject<{ docType: any, chartType: any }>({
    docType: this.docType,
    chartType: this.chartType
  });

  chartType$ = this.chartTypeSubject.asObservable();

  getChartDetailsFromHeader() {
    this.chartTypeSubject.subscribe(data => {
      console.log('Received chart data:', data);
    });
  }

  passChartDetails(newDocType: any, newChartType: any) {
    this.chartTypeSubject.next({
      docType: newDocType,
      chartType: newChartType
    });
  }

  tabType: any = 'no';
  dashboardType: any = 0;
  private tabSubject = new BehaviorSubject<{ tabType: any, dashboardType: any }>({
    tabType: this.tabType,
    dashboardType: this.dashboardType
  });

  tabType$ = this.tabSubject.asObservable();

  passTabType(type: any, dashboard: any) {
    this.tabSubject.next({
      tabType: type,
      dashboardType: dashboard
    })
  }

  getTabTypeData() {
    this.tabSubject.subscribe(data => {
      console.log(data);
    })
  }


}
